import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export const ApiGetPrivacyPolicy = () => {
    return axios.get(`${API_URL_MAIN}/get_privacy_policy`,
    );
};
